import Hero from "../components/Hero";
import Portfolio from "../components/Portfolio";
import WhatWeDo from "../components/WhatWeDo";
import PortfolioGrid from "../components/PortfolioGrid";
import Marketing from "../components/Marketing";
import HomeServices from "../components/HomeServices";
import HomeAbout from "../components/HomeAbout";
import ContactSection from "../components/ContactSection";

function Home() {
  return (
    <>
      <Hero />
      <Portfolio />
      
      <PortfolioGrid />
      <Marketing />
      <WhatWeDo />
       <section id="services">
         <HomeServices />
       </section>
      <HomeAbout />
      <ContactSection />
    </>
  );
}

export default Home;